<template>
  <PlotSurveyQueryTab :value="vegetativePlotDataSource" />
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  import PlotSurveyQueryTab from '@/components/VegetativeMonitoring/PlotDetail/Tabs/PlotSurveyQueryTab'

  export default {
    components: {
      PlotSurveyQueryTab,
    },
    computed: {
      ...monitoringFeatures.mapGetters(['currentFeatureDataSourceData']),
      vegetativePlotDataSource() {
        const data = this.currentFeatureDataSourceData(SOURCE_TYPES.vegetativeMonitoringEnvirodata)
        return data && data.plotData
      },
    },
  }
</script>